import styled from "styled-components";
import cssVars from "../../../../styles/cssVariables.vars";

export const StyledConfirmSessionAction = styled.div`
    box-sizing: border-box;
    width: min(30rem, calc(100vw - 2rem));
    padding: 1.5rem;
    border-radius: 0.5rem;
    background-color: ${cssVars.colorGrey[8]};
    display: flex;
    flex-direction: column;
    gap: 1rem;

    >h2 {
        font-size: 1.125rem;
        font-weight: 600;
        color: ${cssVars.colorGrey[1]};
    }

    >p, >ul {
        font-size: 0.875rem;
        line-height: 1.5;
        color: ${cssVars.colorGrey[3]};
    }

    >ul {
        padding-left: 1.25rem;

        >li {
            list-style: disc;
        }

        >li + li {
            margin-top: 0.25rem;
        }
    }

    >footer {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;

        >button {
            padding: 0.5rem 1rem;
            border-radius: 0.25rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            border: 1px solid ${cssVars.colorGrey[4]};
            background-color: transparent;
            color: ${cssVars.colorGrey[2]};
        }

        >button.confirm {
            border-color: ${cssVars.colorGrey[2]};
            background-color: ${cssVars.colorGrey[2]};
            color: ${cssVars.colorGrey[8]};
        }

        >button.confirm.danger {
            border-color: rgb(220, 60, 55);
            background-color: rgb(220, 60, 55);
            color: white;
        }

        >button:hover {
            filter: brightness(1.1);
        }
    }
`;
